// __APP_ENV__ is injected at build time by webpack DefinePlugin (see webpack.config.mts and docker-bake.hcl).
// Unlike NODE_ENV — which is 'production' for both alpha and production builds — it distinguishes
// production / alpha / dev, so alpha targets its own API instead of production's.
const apiHosts: Record<typeof __APP_ENV__, string> = {
    production: 'https://api.mark-slepkov.com',
    alpha: 'https://api.alpha.mark-slepkov.com',
    dev: 'https://api.loc.mark-slepkov.com',
};

export default {
    // __API_HOST__ is '' when the dev server proxies /REST/ to a remote API (API_PROXY)
    apiHost: __API_HOST__ ?? apiHosts[__APP_ENV__],
};
